<template>
<div id="app">
  <baner />
  <main>
    <div class="container container-padding">
      <div class="">
        <h2 class="text-center">
          Wybierz finansowanie Audi Perfect Lease i skorzystaj z atrakcyjnych korzyści!
        </h2>
      </div>
      <div class="container-row">
        <div class="container-col">
          <div class="container-flex">
            <div class="">
              <img src="@/assets/ochrona.png" alt="">
            </div>
            <div class="">
              <p>
                <strong>
                  Dodatkowa ochrona pogwarancyjna <br>
                  na 12 miesięcy.*
                </strong>
              </p>
            </div>
          </div>
        </div>
        <div class="container-col">
          <div class="container-flex">
            <div class="">
              <img src="@/assets/ubezpieczenie.png" alt="">
            </div>
            <div class="">
              <p>
                Ubezpieczenie za <strong>1 zł</strong>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="">
        <small>
          *zakres- obejmujący wszystkie elementy mechaniczne, elektryczne i elektroniczne zamontowane fabrycznie z wyłączeniem części, które wymagają okresowej wymiany <br> oraz wybranych elementów wyposażenia typu: fotele,  tapicerka, szyby, uszczelki, lampy i.in.
        </small>
      </div>
    </div>
    <div class="flex-row">

      <div class="wrap">
        <search></search>
        <results></results>
      </div>
      <contactForm></contactForm>
    </div>
  </main>
  <section class="advisor-bg">
    <div class="container advisor-padding">
      <div class="">
        <h2 class="text-center">
          O szczegóły zapytaj Doradcę
        </h2>
      </div>
      <div class="advisor">
        <div class="">
          <img src="@/assets/marcin-patalas.jpg" alt="">
        </div>
        <div class="">
          <h2 class="advisor-name">
            Marcin <br>
            Patalas
          </h2>
          <p class="advisor-position">
            Specjalista ds. Sprzedaży
          </p>
          <p>
            tel. kom.: <a class="advisor-link" href="+48 602 700 238">602 700 238</a>
          </p>
          <p>
            <a class="advisor-link" href="mailto:marcin.patalas@porscheinterauto.pl">marcin.patalas@porscheinterauto.pl</a>
          </p>
        </div>
      </div>
    </div>

  </section>
  <div class="container">
    <bottomFooter></bottomFooter>

  </div>

  <loader/>
</div>
</template>

<script>
  import baner from './components/baner.vue'
  import contactForm from './components/form.vue'
  import search from './components/search.vue'
  import results from './components/results.vue'
  import bottomFooter from './components/footer.vue'
  import loader from './components/loader.vue'

  var FontFaceObserver = require('fontfaceobserver');

  export default {
    name: 'app',
    components: {
      baner,
      contactForm,
      search,
      results,
      bottomFooter,
      loader
    },
    mounted() {
      var font = new FontFaceObserver('AudiType');
      font.load().then(function () {
        document.body.className += ' ' + 'font-loaded';
      });


    // UTM FORWARDER
    !function(){function e(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),r.push.apply(r,n)}return r}function t(t){for(var n=1;n<arguments.length;n++){var c=null!=arguments[n]?arguments[n]:{};n%2?e(Object(c),!0).forEach(function(e){r(t,e,c[e])}):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(c)):e(Object(c)).forEach(function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(c,e))})}return t}function r(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}new function(){this.getSearchParams=function(){var e=(arguments.length>0&&void 0!==arguments[0]?arguments[0]:"").replace("?","").split("&"),t=[];if(""!=e)for(var r=0;r<e.length;r++)t[e[r].split("=")[0]]=e[r].split("=")[1];return t},this.createUtmArray=function(){for(var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=0;t<this.utmAccepted.length;t++)this.searchParams[this.utmAccepted[t]]&&(e[this.utmAccepted[t]]=this.searchParams[this.utmAccepted[t]]);return e},this.encodeUrlArray=function(e){var t="";for(var r in e)""!=t&&(t+="&"),t+=r+"="+encodeURIComponent(e[r]);return t},this.utmAccepted=["utm_source","utm_medium","utm_campaign","utm_content","utm_term"],this.searchParams=this.getSearchParams(location.search),this.utmParams=this.createUtmArray(),this.hrefs=document.querySelectorAll("a"),this.hrefsIgnore=["tel","mailto"];for(var e=0;e<this.hrefs.length;e++){var r=this.hrefs[e];if(!new RegExp(this.hrefsIgnore.join("|")).test(r.href)){var n=this.getSearchParams(r.search);n=t({},n,{},this.utmParams),r.search=this.encodeUrlArray(n)}}}}();

    }
  }
</script>

<style lang="scss">
  @import url(./assets/fonts/stylesheet.css);
  html,
  body {
    margin: 0;
    padding: 0;
    font-family: Arial;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 16px;
    @media(max-width: 1280px){
      font-size: 14px;
    }
    @media(max-width: 780px){
      scroll-behavior: smooth;
    }
    position:relative;
    &.font-loaded{
      font-family: 'AudiType';
      textarea{
              font-family: 'AudiType';
      }
    }
  }
  *, *::after, *::before{
    box-sizing:border-box;
  }
  a{
    text-decoration: none;
  }
  main{
    display:block;
    width:100%;
    max-width: 1920px;
    margin: 0 auto;
  }
  h2{
    font-size: 2rem;
    @media(max-width: 600px){
      font-size: 1.5rem;
    }
  }
  .img-responsive {
    max-width: 100%;
    height: auto;
  }
  .text-center{
    width: 100%;
    text-align: center;
  }
  .flex-row{
    display: block;
    width: 100%;
    @media(min-width:780px){
    display: flex;
    justify-content: flex-end;
    }
  }
  .wrap{
    max-width: 1230px;
    width: 100%;
    @media(min-width: 960px){
      padding-left: 1rem;
    }
  }
  .container{
    max-width: 1600px;
    margin: 0 auto;
    &-row{
      display: flex;
      justify-content: space-around;
      margin: 4rem 0;
      @media(max-width: 960px){
        display: block;
      }
    }
    &-col{
      @media(max-width: 960px){
        display: flex;
        justify-content: center;
      }

    }
    &-flex{
      display: flex;
      align-items: center;
      font-size: 1.5rem;
      @media(max-width: 600px){
        text-align: center;
        display: block;
      }
    }
    &-padding{
      padding-bottom: 1rem;
    }
    & p{
      margin-left: 20px;
    }
    @media(max-width: 1600px){
      padding: 0 1rem;
    }
  }
  .advisor{
    display: flex;

    &-name{
      margin-left: 20px;
    }
    &-position{
      font-weight: 700;
    }
    &-link{
      color: #bb0a30;
    }
    &-bg{
      background-color: #f1f1f1;
    }
    &-padding{
      padding: 2rem 0;
      @media(max-width:1600px){
        padding: 2rem 1rem;
      }
    }
    & img{
      @media(max-width: 550px){
        max-width: 100px;
      }
      @media(max-width: 400px){
        margin-left: 20px;
      }
    }
    @media(max-width: 550px){
      align-items: center;
    }
    @media(max-width: 400px){
      display: block
    }
  }
</style>
